var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"transform duration-300",class:{
    'rotate-180': _vm.dir,
  },attrs:{"icon":['fas', 'chevron-down']}})}
var staticRenderFns = []

export { render, staticRenderFns }